export const search = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.2308 14.3077L18.9231 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="11.5385" cy="11.5385" r="4.53846" stroke="currentColor" strokeWidth="2" />
  </svg>
);
